import {
  useEffect,
  useState
} from "react";

import "./notification.css";

import {
  notificationModules
} from "./modules";

function formatRelativeTime(date){

  const seconds =
    Math.floor(
      (Date.now()-date)/1000
    );

  if(seconds<60){

    return `Hace ${seconds} s`;

  }

  const minutes =
    Math.floor(seconds/60);

  if(minutes<60){

    return `Hace ${minutes} min`;

  }

  const hours =
    Math.floor(minutes/60);

  return `Hace ${hours} h`;

}

export default function NotificationCard({

    notification,

    removeNotification,

    index,

    total,

    onAction

}) {

  const [

    visible,

    setVisible

  ] = useState(false);

  const [

    paused,

    setPaused

  ] = useState(false);

  useEffect(() => {

    requestAnimationFrame(() =>

      setVisible(true)

    );

  }, []);

  useEffect(() => {

    if (paused) return;

    const timer = setTimeout(() => {

      setVisible(false);

      setTimeout(() => {

        removeNotification(

          notification.id

        );

      },250);

    },

    notification.duration || 8000

    );

    return () =>

      clearTimeout(timer);

  }, [

    paused,

    notification,

    removeNotification

  ]);

    const module =

        notificationModules[
        notification.type
        ] ||

        notificationModules.system;

    return (

    <div

      className="notification-card"

      onMouseEnter={()=>

        setPaused(true)

      }

      onMouseLeave={()=>

        setPaused(false)

      }

      style={{

          opacity:

            visible ? 1 : 0,

          transform:

            visible

              ? "translateX(0)"

              : "translateX(120px)",

          position: "relative",

          pointerEvents: "auto"

      }}

    >

      {/* Barra */}

      <div

        className="notification-progress"

      />

      {/* Header */}

      <div

        className="notification-header"

      >

        <div

          className="notification-logo"

        >

          {

            notification.clinicLogo

            ?

            (

              <img

                src={
                  notification.clinicLogo
                }

                alt="logo"

              />

            )

            :

            "🦷"

          }

        </div>

        <div

          className="notification-header-text"

        >

          <div

            className="notification-clinic"

          >

            {

              notification.clinicName ||

              "VexaDent"

            }

          </div>

          <div

                className="notification-module"

            >

                <div

                    className="notification-badge"

                    style={{

                        background:

                            module.background,

                        color:

                            module.color

                    }}

                >

                    <span>

                        {module.icon}

                    </span>

                    <div

                        className="notification-badge-dot"

                    />

                    <span>

                        {module.label}

                    </span>

                </div>

          </div>

        </div>

      </div>

      <button

          onClick={() => {

              setVisible(false);

              setTimeout(() => {

                  removeNotification(notification.id);

              }, 250);

          }}

          style={{

            position: "absolute",

            top: 10,

            right: 10,

            width: 24,

            height: 24,

            border: "none",

            borderRadius: 6,

            background: "#f4f7fb",

            color: "#687a90",

            fontSize: 14,

            fontWeight: 700,

            cursor: "pointer",

            display: "flex",

            alignItems: "center",

            justifyContent: "center",

            pointerEvents: "auto",

            transition: "0.2s"

        }}

          title="Cerrar"

      >

          ✕

      </button>

      {/* Paciente */}

      <div

        className="notification-patient"

      >

        {

          notification.title

        }

      </div>

      {/* Mensaje */}

      <div

        className="notification-message"

      >

        {

          notification.message

        }

      </div>

      {/* Footer */}

      <div

        className="notification-footer"

      >

        <div

          className="notification-time"

        >

          {

            formatRelativeTime(

                notification.createdAt

            )

          }

        </div>

        {
            notification.type ===
            "whatsapp" && (

                <div
                    className="notification-buttons"
                >

                    <button
                        className="notification-primary"
                        onClick={() => {

                            notification
                                .onOpenConversation?.();

                            removeNotification(
                                notification.id
                            );

                        }}
                    >

                        Abrir conversación

                    </button>

                    <button
                        className="notification-secondary"
                        onClick={() => {

                            notification
                                .onOpenPatient?.();

                            removeNotification(
                                notification.id
                            );

                        }}
                    >

                        Ver expediente

                    </button>

                </div>

            )
        }

      </div>

    </div>

  );

}
